import { Component, EventEmitter, OnInit, Output, ViewChild, LOCALE_ID, OnDestroy, inject } from "@angular/core";
import { BelegeClientProvider, WawiBelegArt, BelegLookupDto } from "src/app/web-api/web-api";
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl, } from "@angular/forms";
import { finalize, catchError, map, debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { DropdownType, IFormDropDownItem } from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import { formatNumber } from "@angular/common";
import { CstBelegartService } from "src/app/services/wawi/belegart.service";
import { UserService } from "src/app/services/user.service";
import { BelegSelectingEvent } from "./beleg-selecting.event";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import { CstListViewDataSource, ICstListViewColumn } from "src/app/common-components/list-view/models";
import { SelectionModel } from "@angular/cdk/collections";
import { CstListViewComponent } from "src/app/common-components/list-view/list-view.component";
import { MatSort } from "@angular/material/sort";
import { Observable, of, Subject } from "rxjs";
import { format } from "date-fns";
export interface IBelegSelectFilter {
    belegArt: WawiBelegArt;
    sammelNr?: number;
    sammelNrJahr?: number;
    belegNr?: string;
    addressID?: number;
    dateRangeBegin?: Date;
    dateRangeEnd?: Date;
    anlageNr?: string;
}

@Component({
    templateUrl: "./beleg-select-dialog.component.html",
    styleUrls: ["./beleg-select-dialog.component.scss"],
    standalone: false
})
export class WawiApiBelegSelectDialogComponent extends CstResponsivePopupComponentBase<{ belegArt: number, anlageNr: string }, any>
    implements OnInit, OnDestroy {
    private _fb = inject(FormBuilder);
    private _client = inject(BelegeClientProvider);
    private _userService = inject(UserService);
    belegArt = inject(CstBelegartService);
    private _locale = inject(LOCALE_ID);

    private _tmpInitialValues: IBelegSelectFilter = null;
    private get _keySavedFilter() {
        return (
            "BelegSelect_Filter" +
            (this._userService.CurrentUser.mandantID
                ? "_" + this._userService.CurrentUser.mandantID
                : "")
        );
    }
    private filterSubject = new Subject<IBelegSelectFilter>();
    private destroy$ = new Subject<void>();

    // private get _keySavedState() {
    //     return (
    //         "BelegSelect_State" +
    //         (this._userService.CurrentUser.mandantID
    //             ? "_" + this._userService.CurrentUser.mandantID
    //             : "")
    //     );
    // }
    private _filterChangeRecursionGuard = false;

    @Output() belegSelecting = new EventEmitter<BelegSelectingEvent>(false);
    public DropdownType = DropdownType;
    public includedBelegArten = [WawiBelegArt.Angebot, WawiBelegArt.Auftrag, WawiBelegArt.Bestellung];

    public loading = false;
    public filterForm: FormGroup = null;

    public selectedItem: BelegLookupDto = null;

    public sammelNrYearItems: IFormDropDownItem[] = [];

    public get currentTab() {
        return this.filterForm.controls.currentTab.value;
    }
    public set currentTab(value: number) {
        this.filterForm.controls.currentTab.setValue(value);
    }
    public get currentNumberType() {
        return this.filterForm.controls.currentNumberType.value;
    }
    public set currentNumberType(value: number) {
        this.filterForm.controls.currentNumberType.setValue(value);
    }

    @ViewChild(CstListViewComponent) private _tableRef: CstListViewComponent;
    @ViewChild(MatSort) sort: MatSort;

    public cstDataSource: CstListViewDataSource<BelegLookupDto> = null;
    public columns: ICstListViewColumn<BelegLookupDto>[] = null;

    private get selection(): SelectionModel<BelegLookupDto> {
        return this._tableRef.selection;
    }

    public get selected() {
        return this.selection.selected;
    }

    public get selectedCount() {
        return this.selected.length;
    }

    public constructor() {
        super();
        const belegArt = this.belegArt;


        const year = Number.parseInt(
            new Date().getFullYear().toString(10).substring(2, 4),
            10
        );

        for (let i = 0; i < 10; ++i) {
            this.sammelNrYearItems.push({
                label: formatNumber(year - i, this._locale, "2.0-0"),
                value: year - i,
            });
        }

        const today = new Date();
        const begin = new Date(today.getFullYear(), today.getMonth(), 1);
        const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        this.filterForm = this._fb.group({
            belegArt: [WawiBelegArt.None],
            sammelNr: [null],
            sammelNrJahr: [null],
            belegNr: [""],
            addressID: [null],
            dateRangeBegin: [begin],
            dateRangeEnd: [end],
            anlageNr: [""],

            // non-filter values
            currentTab: [0],
            currentNumberType: [0],
        });

        const savedFilter = JSON.parse(localStorage.getItem(this._keySavedFilter));
        if (savedFilter) {
            savedFilter.dateRangeBegin = new Date(savedFilter.dateRangeBegin);
            savedFilter.dateRangeEnd = new Date(savedFilter.dateRangeEnd);
            this.filterForm.patchValue(savedFilter);
        }

        if (this._tmpInitialValues) {
            this.filterForm.patchValue(this._tmpInitialValues);
        }

        this.RefreshValidators();

        this.filterForm.valueChanges.subscribe((filter: IBelegSelectFilter) => {
            if (this._filterChangeRecursionGuard) {
                return;
            }
            this._filterChangeRecursionGuard = true;
            localStorage.setItem(this._keySavedFilter, JSON.stringify(filter));
            this.RefreshValidators();
            this._filterChangeRecursionGuard = false;
        });

        // const savedState = JSON.parse(localStorage.getItem(this._keySavedState));

        // if (savedState) {
        //     this.gridState.sort = savedState.sort || this.gridState.sort;
        // }

        this.cstDataSource = new CstListViewDataSource<BelegLookupDto>({
            sorting: {
                column: "Name",
                direction: "asc",
                enableServerSideSorting: false,
            },
            pagination: {
                pageSize: 25
            }
        });

        this.columns = [
            {
                field: "belegArt",
                header: $localize`:@@Wawi_BelegList_Header_BelegArt:Receipt Type`,
                converter: (value) => belegArt.toString(value),
                width: "15%"
            },
            {
                field: "sammelNr",
                header: $localize`:@@Wawi_BelegList_Header_SammelNr:Collection Number`,
                width: "15%"
            },
            {
                field: "belegNr",
                header: $localize`:@@Wawi_BelegList_Header_BelegNr:Receipt Number`,
                width: "15%"
            },
            {
                field: "belegDatum",
                header: $localize`:@@Wawi_BelegList_Header_BelegDatum:Receipt Date`,
                converter: (value) => format(value, "dd.MM.yyyy"),
                width: "10%"
            },
            {
                field: "anlageNrn",
                header: $localize`:@@Wawi_BelegList_Header_AnlageNr:Facility Numbers`,
                width: "15%"
            },
            {
                field: "kundenAdresse",
                header: $localize`:@@Wawi_BelegList_Header_KundenAdresse:Customer Address`,
                width: "30%"
            },
        ];
    }

    public onSelectionChange(row: BelegLookupDto | null) {
        this.selectedItem = row;
    }

    ngOnInit(): void {
        this.PatchValues({ belegArt: this.data.belegArt, anlageNr: this.data.anlageNr });

        this.filterSubject.pipe(
            debounceTime(400),
            distinctUntilChanged(),
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.cstDataSource.refresh();
        });

        this.cstDataSource.registerFetchDataCallback(() => this.performFetch());
        this.filterForm.valueChanges.subscribe(v => this.filterSubject.next(v))

        this.cstDataSource.refresh();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private performFetch(): Observable<{ data: BelegLookupDto[]; total: number }> {
        if (this.filterForm.invalid) {
            return of({ data: [], total: 0 });
        }

        this.loading = true;

        const filter = this._PrepareSearchFilterForRequest(
            this.filterForm.value as IBelegSelectFilter
        );

        const params = this.getBelegParams(filter);

        return this._client.getBelegList(...params).pipe(
            map(result => ({
                data: result.data,
                total: result.data.length
            })),
            catchError(error => {
                console.error(error);
                return of({ data: [], total: 0 });
            }),
            finalize(() => this.loading = false)
        );
    }

    public PatchValues(formValues: IBelegSelectFilter) {
        if (!this.filterForm) {
            this._tmpInitialValues = formValues;
            return;
        }
        this.filterForm.patchValue(formValues);
    }

    public RefreshValidators() {
        const value = this.filterForm.value;

        let ctrlSammelNr: AbstractControl;
        let ctrlBelegNr: AbstractControl;
        let ctrlBelegArt: AbstractControl;
        let ctrlAddressID: AbstractControl;
        const ctrls = [
            (ctrlSammelNr = this.filterForm.get("sammelNr")),
            (ctrlBelegNr = this.filterForm.get("belegNr")),
            (ctrlBelegArt = this.filterForm.get("belegArt")),
            (ctrlAddressID = this.filterForm.get("addressID")),
        ];

        for (const ctrl of ctrls) {
            ctrl.setValidators(null);
        }

        switch (value.currentTab) {
            case 0:
                switch (value.currentNumberType) {
                    case 0:
                        ctrlSammelNr.setValidators([
                            Validators.compose([Validators.required, Validators.min(1)]),
                        ]);
                        break;
                    case 1:
                        ctrlBelegNr.setValidators([Validators.required, this.noWhitespaceValidator]);
                        break;
                }
                break;
            case 1:
                ctrlAddressID.setValidators([Validators.required]);
                break;
            case 2:
                ctrlBelegArt.setValidators([Validators.required]);
                break;
        }

        for (const ctrl of ctrls) {
            ctrl.updateValueAndValidity({ onlySelf: false });
        }
        this.filterForm.updateValueAndValidity({ onlySelf: false });
    }

    private getBelegParams(filter: IBelegSelectFilter) {
        return [
            filter.belegArt !== WawiBelegArt.None ? [filter.belegArt] : undefined,
            filter.sammelNr || undefined,
            filter.sammelNrJahr ?? undefined,
            filter.belegNr,
            undefined,
            filter.addressID || undefined,
            filter.dateRangeBegin || undefined,
            filter.dateRangeEnd || undefined,
            filter.anlageNr || undefined,
            false,
            undefined,
            this.cstDataSource.state.pagination.offset || 0,
            this.cstDataSource.state.pagination.pageSize || 50,
            undefined
        ] as const;
    }

    public OnClear() {
        const tab = this.currentTab;
        const numberType = this.currentNumberType;
        this.filterForm.reset();
        this.selectedItem = null;
        this.currentTab = tab;
        this.currentNumberType = numberType;
    }

    public OnSelect() {
        if (!this.selectedItem) {
            return;
        }
        const event = new BelegSelectingEvent(this.selectedItem);
        this.belegSelecting.emit(event);
        if (event.isCancelled) {
            return;
        }
        if (event.shouldSubscribeToAsyncCancellation) {
            event.isCancelled$.subscribe(cancelled => {
                if (!cancelled) {
                    this.close(this.selectedItem);
                }
            });
            return;
        }
        this.close(this.selectedItem);
    }

    public OnCancel() {
        this.close(null);
    }

    public onSelectedTabChange(index: number) {
        this.currentTab = index;
    }

    private _PrepareSearchFilterForRequest(filter: IBelegSelectFilter) {
        const value = this.filterForm.value;
        const result: IBelegSelectFilter = { belegArt: WawiBelegArt.None };

        switch (value.currentTab) {
            case 0:
                switch (value.currentNumberType) {
                    case 0:
                        result.sammelNr = filter.sammelNr;
                        result.sammelNrJahr = filter.sammelNrJahr;
                        result.belegArt = filter.belegArt;
                        break;
                    case 1:
                        result.belegNr = filter.belegNr;
                        break;
                }
                break;
            case 1:
                result.addressID = filter.addressID;
                result.belegArt = filter.belegArt;
                result.dateRangeBegin = filter.dateRangeBegin;
                result.dateRangeEnd = filter.dateRangeEnd;
                break;
            case 2:
                result.belegArt = filter.belegArt;
                result.anlageNr = filter.anlageNr;
                result.dateRangeBegin = filter.dateRangeBegin;
                result.dateRangeEnd = filter.dateRangeEnd;
                break;
        }

        return result;
    }

    private noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'required': true };
    }
}
